import { Injectable } from '@angular/core';
import { NotificationService, NotificationSettings } from '@progress/kendo-angular-notification';

@Injectable({
  providedIn: 'root'
})
export class RomeNotificationService {
  private readonly notificationSettings: NotificationSettings;
  private readonly errorStyle = {
    style: 'error',
    icon: true
  };
  private readonly successStyle = {
    style: 'success',
    icon: true
  };
  private readonly infoStyle = {
    style: 'info',
    icon: true
  };

  constructor(private readonly notificationService: NotificationService) {
    this.notificationSettings = new NotificationSettings();
    this.notificationSettings.animation = { type: 'fade', duration: 500 };
    this.notificationSettings.hideAfter = 3000;
    this.notificationSettings.position = { horizontal: 'right', vertical: 'bottom' };
    this.notificationSettings.height = 35;
  }

  public showError(message: string): void {
    this.showNotification(this.errorStyle, message);
  }

  public showSuccess(message: string): void {
    this.showNotification(this.successStyle, message);
  }

  public showInfo(message: string): void {
    this.showNotification(this.infoStyle, message);
  }

  private showNotification(type, message: string): void {
    if (!message) {
      return;
    }
    this.notificationSettings.content = message;
    this.notificationSettings.type = type;
    this.notificationService.show(this.notificationSettings);
  }
}
